module.exports = __webpack_public_path__ + "img/004-nun.25131a0c.png";